module.exports = __webpack_public_path__ + "6481cf11f736e14eae889cb6c012c8e5.svg";